






















































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { GetUserInfo, PwdLogin, CodeLogin, GetPhoneCode } from '../api/login/index';
import request from '@/utils/request.util';
import { AccountModule } from '@/store/modules/account';
import AgreementConsent from '../components/agreement-consent.vue';
const validatePhone = (rule: any, value: string, callback: any) => {
  const reg = /^1\d{10}$/;
  if (!reg.test(value)) {
    callback(new Error('请输入正确的手机号'));
  } else {
    callback();
  }
};
@Component({
  components: {
    AgreementConsent,
  },
})
export default class Index extends Vue {
  pwdLoginFormRef = null;
  phoneLoginFormRef = null;
  pwdLoginForm = {
    mobile: '',
    password: '',
    validate: true,
  };
  phoneLoginForm = {
    mobile: '',
    code: '',
    validate: true,
  };
  pwdLoginFormRules = {
    mobile: [
      {
        required: true,
        message: '请输入你的账号',
        trigger: 'blur',
      },
      { validator: validatePhone, trigger: 'blur' },
    ],
    password: [
      {
        required: true,
        message: '请输入你的密码',
        trigger: 'blur',
      },
    ],
  };
  phoneLoginFormRules = {
    mobile: [
      {
        required: true,
        message: '请输入你的手机号',
        trigger: 'blur',
      },
      { validator: validatePhone, trigger: 'blur' },
    ],
    code: [
      {
        required: true,
        message: '请输入你获取到的验证码',
        trigger: 'blur',
      },
    ],
  };
  loading = false;
  buttonText = '获取验证码';
  disabled = false;
  duration = 60;
  timer: any = null;
  agreementAccepted = false;
  mounted() {
    AccountModule.logout();
    window.addEventListener('keydown', this.keyDown);
  }
  async pwdLogin() {
    if (!this.ensureAgreementAccepted()) return;
    (this.$refs['pwdLoginFormRef'] as any).validate().then((isvalidate: Boolean) => {
      if (isvalidate) {
        PwdLogin({ ...this.pwdLoginForm, agreementAccepted: true }).then((res: any) => {
          this.$message.success('登录成功');
          AccountModule.setToken({ key: 'user_token', token: res.token });
          res.token && request.setToken(res.token);
          const redirect = (this.$route.query.redirect as string) || '/home';
          this.$router.replace({ path: redirect });
        });
      }
    });
  }

  async phoneLogin() {
    if (!this.ensureAgreementAccepted()) return;
    (this.$refs['phoneLoginFormRef'] as any).validate().then((res: Boolean) => {
      if (res) {
        CodeLogin({ ...this.phoneLoginForm, agreementAccepted: true }).then(res => {
          this.$message.success('登录成功');
          AccountModule.setToken({ key: 'user_token', token: res.token });
          res.token && request.setToken(res.token);
          const redirect = (this.$route.query.redirect as string) || '/home';
          this.$router.replace({ path: redirect });
        });
      }
    });
  }

  keyDown(e: any) {
    if (e.keyCode == 13 || e.keyCode == 100) {
      if (this.activeTab == '账户密码登录') {
        this.pwdLogin();
      } else {
        this.phoneLogin();
      }
    }
  }

  activeTab = '账户密码登录';

  clickTab(e: any) {
    this.activeTab = e.label;
  }

  async getPhoneCode() {
    if (this.disabled) return;
    if (!this.ensureAgreementAccepted()) return;
    const reg = /^1\d{10}$/;
    if (!reg.test(this.phoneLoginForm.mobile)) {
      this.$message.error('请输入正确的手机号');
      return;
    }
    await GetPhoneCode({
      validate: true,
      mobile: this.phoneLoginForm.mobile,
      agreementAccepted: true,
    });
    this.disabled = true;
    let n = 60;
    this.timer = setInterval(() => {
      if (n > 0) {
        n--;
        this.buttonText = '重新获取(' + n + 's)';
      } else {
        clearInterval(this.timer);
        this.buttonText = '获取验证码';
        this.disabled = false;
      }
    }, 1000);
  }

  ensureAgreementAccepted() {
    if (this.agreementAccepted) return true;
    this.$message.warning('请先阅读并同意《星云平台用户协议》和《星云平台隐私政策》');
    return false;
  }

  toRegister() {
    this.$router.push({
      path: '/register',
    });
  }
}
